import { useHistory } from "react-router";

export function useRequiredURLSearchParam(key: string, redirectUrl: string) {
  const history = useHistory();
  const param = new URLSearchParams(window.location.search).get(key);
  if (param === null) {
    history.push(redirectUrl);
    return "";
  }
  return param;
}
